// import '../fake-db';
import { useRoutes } from "react-router-dom";
import { Suspense } from "react";
import { MatxTheme } from "./components";
import { AuthProvider } from "./contexts/JWTAuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import { ChatProvider } from "./contexts/ChatContext";
import routes from "./routes";
import { useSelector } from "react-redux";
import { isGranded } from "./utils/compatibility"; // Using compatibility layer
import SnackBar from "./component/SnackBar";
import PageSuspense from "./components/common/PageSuspense";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const App = () => {
  // Support both old and new store structure for backward compatibility
  const permissions = useSelector((state) => 
    state.permission?.permissions || state.config?.Permission || []
  );
  const { children } = routes[0];
  const filteredChildren = children.filter(
    (element) => !element.permission || isGranded(element.permission, permissions)
  );
  routes[0].children = filteredChildren;
  const content = useRoutes(routes);

  return (
    <SettingsProvider>
      <MatxTheme>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <AuthProvider>
            <ChatProvider>
              <Suspense fallback={<PageSuspense />}>
                {content}
              </Suspense>
            </ChatProvider>
          </AuthProvider>
        </LocalizationProvider>
      </MatxTheme>
      <SnackBar />
    </SettingsProvider>
  );
};

export default App;
